const youtubeDialogModule = (() => {
    let dialog, iframe, closeBtn, initialized = false;
    const YOUTUBE_VIDEO_ID = 'aQKwdpKNTHg';

    const open = () => {
        if (!dialog || !iframe) {
            createDialog();
            initialized = true;
        }
        if (!iframe || !dialog) {
            return;
        }
        iframe.src = `https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}?autoplay=1&mute=1`;
        dialog.style.display = 'flex';
        sa_event('demowatched');
        if (typeof gtag === 'function') {
            gtag('event', 'demowatched', {
                event_category: 'video',
                event_label: 'Homepage Demo Video',
                value: 1
            });
        }

    };

    const close = () => {
        unload();
    };

    const unload = () => {
        // Full teardown (SPA-safe)
        if (iframe) iframe.src = '';
        if (closeBtn) closeBtn.removeEventListener('click', close);
        if (dialog && dialog.parentNode) dialog.parentNode.removeChild(dialog);
        dialog = null;
        iframe = null;
        closeBtn = null;
        initialized = false;
    };




    const createDialog = () => {
        dialog = document.createElement('div');
        dialog.id = 'youtubeDialog';
        dialog.style.cssText = `
            display: none;
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background: rgba(0,0,0,0.7);
            justify-content: center;
            align-items: center;
            z-index: 9999;
            padding: 20px;
            box-sizing: border-box;
        `;

        const dialogContent = document.createElement('div');
        dialogContent.style.cssText = `
            position: relative;
            width: 100%;
            max-width: 720px;
            background: #000;
            border-radius: 6px;
        `;

        const aspectWrapper = document.createElement('div');
        aspectWrapper.style.cssText = `
            position: relative;
            padding-bottom: 56.25%;
            height: 0;
            overflow: hidden;
            border-radius: 6px;
        `;

        iframe = document.createElement('iframe');
        iframe.allowFullscreen = true;
        iframe.style.cssText = `
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border: none;
            border-radius: 6px;
        `;

        aspectWrapper.appendChild(iframe);

        closeBtn = document.createElement('button');
        closeBtn.textContent = '✕';
        closeBtn.style.cssText = `
            position: absolute;
            top: 8px;
            right: 8px;
            background: white;
            color: black;
            border: none;
            border-radius: 50%;
            width: 30px;
            height: 30px;
            font-size: 16px;
            cursor: pointer;
            z-index: 1;
        `;
        closeBtn.addEventListener('click', close);

        dialogContent.appendChild(closeBtn);
        dialogContent.appendChild(aspectWrapper);
        dialog.appendChild(dialogContent);
        document.body.appendChild(dialog);
    };

    return { open,unload };
})();

export default youtubeDialogModule;
